<template>
  <div id="app">
    <MusicSorter />
  </div>
</template>

<script>
import MusicSorter from "./components/MusicSorter.vue";

export default {
  name: "App",
  components: {
    MusicSorter,
  },
};
</script>

<style>
html {
  background: url("./assets/Background.jpg");
  font-family: "Verdana", sans-serif;
}
</style>